/**
 * 后端接口请求方式
 * */

import axios from 'axios'
import {Message} from 'element-ui'
import {setToken, getToken, removeToken} from './auth'
import {resetUrl} from "../../url";
import {getProjectCode} from "./code";
// import {setUserLogout} from "@/api/auth";

export function setServer(base) {
    let url = base ? base : resetUrl
    axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
    const service = axios.create({
      // axios中请求配置有baseURL选项，表示请求URL公共部分
      baseURL: url,
      // 超时 10分钟
      timeout: 600000
    })
// request拦截器
    service.interceptors.request.use(config => {
      if (config.content) {
        axios.defaults.headers['Content-Type'] = config.content
      }
      if (config.responseType) {
        axios.defaults.responseType = config.responseType
      }
      // 是否需要设置 token
      if (getToken()) {
        config.headers.common['authentication'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      // 设置服务器code
      let path = url.split('/apiv1')[1] ? '/apiv1' + url.split('/apiv1')[1] : ''; // 获取服务器网关配置
      if (config.url !== '/auth/toLogin') {
        config.headers.common['location'] = window.location.href; // 登录过期时返回页面地址
      } else {
        //设置过期跳转路径（登录时设置）
        config.headers.common['x-location'] = 'http://' + window.location.host;
      }
      // 平台code
      config.headers.common['operatecode'] = getProjectCode();
      // get请求映射params参数
      if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
          const value = config.params[propName];
          var part = encodeURIComponent(propName) + "=";
          if (value !== null && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
              for (const key of Object.keys(value)) {
                let params = propName + '[' + key + ']';
                var subPart = encodeURIComponent(params) + "=";
                url += subPart + encodeURIComponent(value[key]) + "&";
              }
            } else {
              url += part + encodeURIComponent(value) + "&";
            }
          }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
      }
      // post/put表单提交
      if ((config.method === 'put' || config.method === 'post') && config.forms) {
        let queryParams = new FormData();
        for (const propName of Object.keys(config.forms)) {
          queryParams.append(propName, config.forms[propName]);
        }
        config.data = queryParams;
      }

      return config
    }, error => {
      Promise.reject(error)
    })

// 响应拦截器
    service.interceptors.response.use(res => {
        if (res.headers.authentication) {
          setToken(res.headers.authentication)
        }
        // 非数据流形式
        if (!res.config.responseType||res.config.responseType !== 'arraybuffer') {
          // 未设置状态码则默认成功状态
          const code = res.data.status;
          // 获取错误信息
          const msg = res.data.message;
          if (code == 6000) {
            Message({
              message: msg,
              type: 'error',
              showClose: true
            })
            removeToken();
            location.replace('/');
          } else if (code != '0000' && code != 1005 && code != 2000 && code != 200 && code != 1090) { // 1005暂无数据
            Message({
              message: msg,
              type: 'error'
            })
            return {data: null};
          } else {
            return res.data
          }
        } else {
          return res.data
        }
      },
      error => {
        let {message} = error;
        if (message == "Network Error") {
          message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
          message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
          message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
          message: message,
          type: 'error',
          showClose: true
        })
        return Promise.reject(error)
      }
    )

    return service
}




// WEBPACK FOOTER //
// ./src/utils/axios.js